"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _eyeDisabled = require("@catalytic/catalytic-icons/lib/glyphs/eye-disabled.svg");
var _eye = require("@catalytic/catalytic-icons/lib/glyphs/eye.svg");
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _excluded = ["classes", "className", "disabled", "displayErrors", "hasError", "hasRequired", "hasSuccess", "hasValidation", "inputClassName", "inputRef", "name", "readOnly", "required", "setDisplayErrorsState", "setLoadingState", "theme", "title", "type"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ComponentType, type ElementRef } from 'react';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'PasswordInput';
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      position: 'relative'
    },
    input: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.truncate), {}, {
      '&:required:invalid': {
        paddingRight: theme.variables.inputRequiredPaddingRight,
        '& ~ $button': {
          display: 'none'
        }
      },
      '&:focus:required:invalid, &:required:valid': _objectSpread(_objectSpread({}, theme.mixins.inputPadding), {}, {
        '& ~ $required': {
          display: 'none'
        }
      }),
      '&:valid, &:required:valid': {
        paddingRight: theme.variables.inputRequiredPaddingRight
      }
    }),
    displayErrors: {
      '&:valid': theme.mixins.inputSuccess,
      '&:invalid': theme.mixins.inputError
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    required: {},
    button: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      padding: "0 ".concat(theme.functions.toRem(theme.variables.inputPaddingRight)),
      backgroundColor: 'transparent',
      color: theme.colors.battleshipGrey,
      fontSize: theme.typography.baseText.lineHeight,
      cursor: 'pointer',
      '&:hover': {
        color: theme.colors.black
      },
      '&:disabled': theme.mixins.disabled
    }
  };
};
/*:: export type PasswordInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    displayErrors: boolean,
    hasError: boolean,
    hasRequired: boolean,
    hasSuccess: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed
  };*/
/*:: type State = {
  type: string
};*/
var PasswordInput = /*#__PURE__*/function (_PureComponent) {
  function PasswordInput() {
    var _this;
    (0, _classCallCheck2.default)(this, PasswordInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PasswordInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      type: _this.props.type || 'password'
    });
    (0, _defineProperty2.default)(_this, "handleClick", function (event /*: SyntheticEvent<HTMLButtonElement>*/) {
      event.preventDefault();
      var type = _this.state.type;
      return _this.setState({
        type: type === 'password' ? 'text' : 'password'
      });
    });
    return _this;
  }
  (0, _inherits2.default)(PasswordInput, _PureComponent);
  return (0, _createClass2.default)(PasswordInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        className = _this$props.className,
        disabled = _this$props.disabled,
        displayErrors = _this$props.displayErrors,
        hasError = _this$props.hasError,
        hasRequired = _this$props.hasRequired,
        hasSuccess = _this$props.hasSuccess,
        hasValidation = _this$props.hasValidation,
        inputClassName = _this$props.inputClassName,
        ref = _this$props.inputRef,
        name = _this$props.name,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        setDisplayErrorsState = _this$props.setDisplayErrorsState,
        setLoadingState = _this$props.setLoadingState,
        theme = _this$props.theme,
        title = _this$props.title,
        typeProp = _this$props.type,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var type = this.state.type;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        title: title
      }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.displayErrors, displayErrors), classes.error, hasError), classes.success, hasSuccess), inputClassName),
        "data-name": name,
        "data-testid": name || 'password-input',
        disabled: disabled || readOnly
      }, _objectSpread({
        name: name,
        readOnly: readOnly,
        ref: ref,
        required: required,
        type: type
      }, props))), /*#__PURE__*/_react.default.createElement(_InputRequired.default, {
        className: classes.required,
        disabled: disabled,
        hasRequired: hasRequired,
        readOnly: readOnly,
        required: required
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: classes.button,
        "data-testid": "password-eye",
        disabled: disabled || readOnly,
        onClick: this.handleClick,
        type: "button"
      }, type === 'password' ? /*#__PURE__*/_react.default.createElement(_eyeDisabled.ReactComponent, null) : /*#__PURE__*/_react.default.createElement(_eye.ReactComponent, null)));
    }
  }]);
}(_react.PureComponent); // TODO: Type props to component
(0, _defineProperty2.default)(PasswordInput, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(PasswordInput, "defaultProps", {
  autoComplete: 'new-password',
  disabled: false,
  displayErrors: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  readOnly: false,
  required: false,
  type: 'password'
});
/*:: type EnhancedProps = Object;*/
var _default = exports.default = ((0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _injectSheet.default)(Style))(PasswordInput) /*: ComponentType<EnhancedProps>*/);
//# sourceMappingURL=PasswordInput.js.map